import { Component } from '@angular/core'
import { DefaultRowComponent } from '../default-row/default-row.component'
import { CustomTableService } from '../../service/custom-table.service'

@Component({
    selector: 'app-shipment-credit-claim-row',
    templateUrl: './shipment-credit-claim-row.component.html',
    styleUrls: ['./shipment-credit-claim-row.component.scss'],
    standalone: false
})
export class ShipmentCreditClaimRowComponent extends DefaultRowComponent {
  constructor(private customTableService: CustomTableService) {
    super()
  }

  public get importCompleted(): boolean {
    const id = this.row[this.uid]
    const data = this.customTableService.dataSource[id]
    return data.status === 'Completed'
  }

  public onClick(control: any): void {
    this.customTableService.clicked(control, this.row)
  }
}
